import request from "@/utils/request";
const BASE_API = process.env.VUE_APP_BASE_API;
import {isProductionEnvironment} from '../utils/index'
export function getAllOrderTypeList(param) {
    let url = ''
    if(isProductionEnvironment()){
      url = `https://pay.mktindex.com/api/all_order_type_list`
    }else{
      url = `https://paytest.mktindex.com/api/all_order_type_list`
    }
    return request({
        url: url,
        method: "get",
        params: param,
    });
}

export function getPayDetail(param) {
  let url = ''
    if(isProductionEnvironment()){
      url = `https://pay.mktindex.com/api/pay`
    }else{
      url = `https://paytest.mktindex.com/api/pay`
    }
  return request({
    url: url,
    method: "get",
    params: param,
  });
}

export function queryPay(param) {
  let url = ''
    if(isProductionEnvironment()){
      url = `https://pay.mktindex.com/api/query`
    }else{
      url = `https://paytest.mktindex.com/api/query`
    }
  return request({
        url: url,
        method: "get",
        params: param,
    });
}
